'use strict';

const $ = require('jquery');

module.exports = function poll(url, cb = Function(), interval = 800, maxInterval = 20000, _defaultInterval = interval) {

	if(!url) {
		return;
	}

	if(interval > maxInterval) {
		interval = maxInterval;
	}

	const start = new Date().getTime();

	return $.get(url)
		.done(cb)
		.always(() => {

			const duration = new Date().getTime() - start;
			let nextInterval = _defaultInterval;

			if(duration > 1000) {
				nextInterval = duration > 1500 ?
					interval * 3 :
					interval * 1.25;
			}

			const next = poll.bind(null, url, cb, nextInterval, maxInterval, _defaultInterval);
			setTimeout(next, interval);

		});

};